import React from "react";
import { Button, Flex, Popconfirm } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { NavigationPath } from "../../helpers/constants";

const ActionButtons = ({
  navigateToAdd,
  navigateToEdit,
  handleDelete,
  navigateToDetails,
  selectedUser,
}) => {
  const popConfirmTitle = () => {
    const location = window.location.pathname;

    const singleOfferResponsesPattern = /^\/offer-request\/[^/]+\/responses$/;
    const isSingleOfferResponsesRoute =
      singleOfferResponsesPattern.test(location);

    switch (true) {
      case location === NavigationPath.OFFERS_ROUTE:
        return selectedUser.length === 1
          ? `Obriši ponudu broj ${selectedUser[0]?.broj}`
          : `Obriši izabrane ponude`;

      case location === NavigationPath.USERS_ROUTE:
        return selectedUser.length === 1
          ? `Obriši korisnika ${selectedUser[0]?.ime}`
          : "Obriši izabrane korisnike";
      case location === NavigationPath.SUPPLIERS_ROUTE:
        return selectedUser.length === 1
          ? `Obriši dobavljača ${selectedUser[0]?.kompanija}`
          : "Obriši izabrane dobavljače";
      case location === NavigationPath.BRANDS_ROUTE:
        return selectedUser.length === 1
          ? `Obriši brand ${selectedUser[0]?.name}`
          : `Obriši izabrane brandove`;
      case location === NavigationPath.OFFER_RESPONSES_ROUTE:
        return selectedUser.length === 1
          ? `Obriši ${selectedUser[0]?.name}`
          : `Obriši izabrane odgovore`;
      case location === NavigationPath.OFFER_REQUESTS_ROUTE:
        return selectedUser.length === 1
          ? `Obriši ${selectedUser[0]?.name}`
          : `Obriši izabrane zahtjeve`;
      case isSingleOfferResponsesRoute:
        return selectedUser.length === 1
          ? `Obriši ${selectedUser[0]?.insurance.name}`
          : `Obriši izabrane odgovore`;
    }
  };

  return (
    <Flex gap="small">
      {navigateToAdd && (
        <Button
          onClick={navigateToAdd}
          className="text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm"
          icon={<PlusOutlined />}
        >
          Dodaj
        </Button>
      )}

      {navigateToDetails && (
        <Button
          onClick={navigateToDetails}
          className="text-sm text-white bg-dark-blue font-medium rounded-sm border-dark-blue shadow-sm sm:w-auto md:w-[132px]"
          disabled={selectedUser?.length !== 1}
        >
          <EyeOutlined className="hidden sm:inline-flex" />
          <span className="ms-0 sm:ms-2">Pogledaj</span>
        </Button>
      )}

      {navigateToEdit && (
        <Button
          onClick={navigateToEdit}
          className="text-sm text-white bg-dark-blue font-medium w-[132px] rounded-sm border-dark-blue shadow-sm"
          icon={<EditOutlined />}
        >
          Uredi
        </Button>
      )}

      <Popconfirm
        okType="default"
        title={popConfirmTitle}
        onConfirm={handleDelete}
        okText="Da"
        cancelText="Ne"
      >
        <Button
          disabled={!selectedUser || selectedUser?.length === 0}
          className="text-sm text-white bg-red-orange font-medium w-[132px] rounded-sm border-red-orange shadow-sm"
          icon={<DeleteOutlined />}
        >
          Obriši
        </Button>
      </Popconfirm>
    </Flex>
  );
};

export default ActionButtons;
